import React, { use, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api, { getCart } from "services/api";
import Breadcrumbs from "components/common/Breadcrumbs";
import styles from "./Panier.module.css";
import archiveStyle from "styles/modules/Archives.module.css";
import ArrowIcon from "assets/icons/arrow";
import CloseIcon from "assets/icons/close";
import { TrashBin } from "react-ionicons";
import TrashIcon from "assets/icons/trash";
import Button from "components/common/Button";
import PanierSummary from "components/common/PanierSummary";
import PanierAuth from "components/common/PanierAuth";
import { useCart } from "contexts/CartContext";
import useAccessibility from "hooks/useAccessibility";
import { useAuth } from "contexts/AuthContext";
import Spinner from "components/common/Spinner";
import { Helmet } from "react-helmet";



const PanierPage = () => {
  const { spectacleSlug } = useParams();
  const [loading, setLoading] = useState(true);


  const { selectedOption } = useAccessibility();

  useEffect(() => {
    console.log("selectedOption", selectedOption);

  }, [selectedOption]);

  const { isLoggedIn } = useAuth();

  const { cartItems, cartQuantityForEachDate, removeFromCart, relaodCart, addToCart, emptyCart, checkDisponibility, loadingCart, timeExpiration } = useCart();


  useEffect(() => {
    relaodCart();
  }, []);


  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

  useEffect(() => {

    const handleResize = () => {
      window.requestAnimationFrame(() => {
        setIsMobile(window.innerWidth <= 991);
      });
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* if (loadingCart) {
    return <div className={styles.loadingContainer}>
      <Spinner />
    </div>;
  } */


  return (
    <>
      <Helmet>
        <title>Panier - Pharos</title>
        <meta name="description" content="Gérez votre panier, ajoutez ou retirez des articles, et finalisez votre commande en toute simplicité." />
        <meta property="og:title" content="Panier - Pharos" />
        <meta property="og:description" content="Gérez votre panier, ajoutez ou retirez des articles, et finalisez votre commande en toute simplicité." />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className={`page-content section-no-padding ${styles.pageContent}`}>
        <section className={`global-section global-section-title ${styles.section}`}>
          <div className={`global-container ${styles.content}`}>
            <div className={archiveStyle.header}>
              <h1 className="h2">Panier</h1>
              <Breadcrumbs
                pageType={'isPage'}
                element={{ title: "Panier" }}
              />
            </div>
          </div>
        </section>
        <section className={`global-section ${styles.section} ${selectedOption === "blackTheme" ? styles.dark : ""}`}>
          <div className={`global-container ${styles.content}`}>
            <div className={styles.cart}>
              <div className={styles.title}>Votre commande en cours</div>
              {cartItems.length > 0 ? <p className={styles.description}>
                Pour valider votre Panier et finaliser votre commande, cliquez sur le bouton <span className={styles.attention}>Finaliser votre commande</span> qui figure au pied de cette page.
                <br /> Un panier est valable  pendant 15 minutes. Vos places vous sont réservées pendant ce temps. <br /> Validité de votre panier jusqu'à <span className={styles.attention}>{timeExpiration.split('T')[1].split(':')[0]}:{timeExpiration.split('T')[1].split(':')[1]}</span>.
              </p> :
                <p className={`${styles.description} ${styles.empty}`}>
                  Votre panier est actuellement vide.
                </p>
              }

              {
                cartItems.length > 0 &&
                <div className={styles.cartContainer}>
                  <div className={styles.emptyAction} onClick={() => {
                    emptyCart().then(() => {
                      relaodCart();
                    })
                  }}
                    role="button"
                    aria-label="Vider complètement le panier"
                    tabIndex="0"
                  >
                    <CloseIcon />
                    <span>Vider le panier</span>
                  </div>
                  <ul className={styles.cartList}>
                    {cartItems.map(item => <li>
                      <div className={styles.ProductImage}>
                        <Link to={`/programme/spectacle/${item.slug}`}>
                          <img src={item.poster ? item.poster.path : ""} alt={`Affiche de ${item.spectacleName}`} />
                        </Link>
                      </div>
                      <div className={styles.ProductInfo}>
                        <Link to={`/programme/spectacle/${item.slug}`}>
                          <div className={styles.ProductTitle}>{item.spectacleName}</div>
                        </Link>
                        <div className={styles.ProductDescription}>{item.tarifName}</div>
                        <div className={styles.ProductDate}>{item.dateLongue + " à " + item.heure}</div>
                        <div className={styles.ProductDescription}>{item.lieu + ", " + item.ville}</div>
                        <div className={styles.ProductPrice}>
                          {(() => {
                            const price = item.prixUnitaire;
                            const amount = price * item.quantite;
                            return amount;
                          })().toFixed(2).replace('.', ',')} €
                        </div>
                      </div>
                      <div className={styles.ProductAction}>
                        <div className={styles.ProductQuantity}>
                          <input
                            value={item.quantite}
                            type="number"
                            name="quantity"
                            min={0}
                            max={99}
                          />
                          <span
                            className={styles.commandItemQuantityPlus}
                            onClick={() => {
                              addToCart({ dateId: item.spectacleDateId, tarifId: item.tarifId ?? item.streamTarifId, slug: item.slug, quantity: 1, streamable: !!item.streamTarifId }).then(() => {
                                relaodCart();
                              })
                            }}
                            role="button"
                            aria-label={`Augmenter la quantité de ${item.spectacleName}`}
                            tabIndex="0"
                          ></span>
                          <span
                            className={styles.commandItemQuantityMinus}
                            onClick={() => {
                              addToCart({ dateId: item.spectacleDateId, tarifId: item.tarifId ?? item.streamTarifId, slug: item.slug, quantity: -1, streamable: !!item.streamTarifId }).then(() => {
                                relaodCart();
                              })
                            }}
                            role="button"
                            aria-label={`Diminuer la quantité de ${item.spectacleName}`}
                            tabIndex="0"
                          ></span>
                        </div>
                        <div className={styles.ProductPrice}>
                          {(() => {
                            const price = item.prixUnitaire;
                            const amount = price * item.quantite;
                            return amount;
                          })().toFixed(2).replace('.', ',')} €
                        </div>
                        <div className={styles.ProductDelete}
                          onClick={() => {
                            removeFromCart({ itemId: item.id }).then(() => {
                              relaodCart();
                            });
                          }}
                          role="button"
                          aria-label={`Supprimer ${item.spectacleName} du panier`}
                          tabIndex="0"
                        >
                          <TrashIcon />
                        </div>
                      </div>
                    </li>)}
                  </ul>
                  <div className={styles.cartTotal}>
                    Total : {
                      (() => {
                        const total = cartItems.reduce((acc, item) => {
                          const price = item.prixUnitaire;
                          return acc + (price * item.quantite);
                        }, 0);
                        return total;
                      })().toFixed(2).replace('.', ',')} €
                  </div>
                </div>


              }
              <div className={styles.cartActions}>

                <a href="/programme" className={`${styles.BackToProgram}`}>
                  <ArrowIcon /> <span>Poursuivre vos achats</span>
                </a>
                {cartItems.length > 0 && <div className={styles.cartActionsButtons}>
                  <Link to="/panier/finaliser-votre-commande">
                    <Button>
                      Finaliser votre commande
                    </Button>
                  </Link>
                  <div className={styles.emptyAction}
                    onClick={() => {
                      emptyCart().then(() => {
                        relaodCart();
                      })
                    }}
                    role="button"
                    aria-label="Vider complètement le panier"
                    tabIndex="0"
                  >
                    <CloseIcon />
                    <span>Vider le panier</span>
                  </div>
                </div>}
              </div>
            </div>
          </div>
        </section>
      </div >
    </>
  );
};

export default PanierPage;
